import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Loading } from '../../components/Loading';
import {
  PATH_FOLDER_BUSINESS_EVENTS,
  PATH_FOLDER_DEFAULT,
  PATH_FOLDERS_DEFAULT,
} from '../../app/constants/paths.constant';
import { Calendar } from '../../components/Illustrations/Calendar';
import { useBuildPaths } from '../../hooks/useBuildPaths.hook';
import { useFolderContext } from '../../contexts/FolderContext/hooks/useFolderContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const FolderBusinessEventsPage = () => {
  const { folderId, folder } = useFolderContext();

  const { paths } = useBuildPaths(
    {
      default: PATH_FOLDER_DEFAULT,
      businessEvents: PATH_FOLDER_BUSINESS_EVENTS,
    },
    { folderId },
  );

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle(
            'Liste des Événements Métier du Dossier',
            folder?.code,
          )}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_FOLDERS_DEFAULT,
            label: 'dossiers',
            key: 'folders',
          },
          {
            to: paths.default,
            label: 'dossier',
            key: 'folder',
          },
          {
            to: paths.businessEvents,
            label: 'événements métier',
            key: 'businessEvents',
          },
        ]}
      />
    </>
  );

  const titleContent = (
    <PageTitle title="Liste des Événements Métier du Dossier" />
  );

  if (folder) {
    return (
      <>
        {beforeTitleContent}
        <PageTitle code={folder.code} title={folder.consolidation.title} />
        <Calendar />
      </>
    );
  }

  return (
    <>
      <Loading />
      {beforeTitleContent}
      {titleContent}
    </>
  );
};
